import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import { getFullDateString } from '../../../Util/dateTime';

import auth from '../../../Login/authService'

class DailyreportsList extends Component {
  render() {
    const { dailyReports, toggleApproved, toggleInvoiced,toggleBog, goToDailyReport, workplaceId } = this.props;

    let token = auth.getToken();
    let _url = process.env.REACT_APP_webApiEndPoint +
      "api/dailyreport/" +
      workplaceId +
      "/print" +
      "?token=" +
      token;

    var Items = dailyReports.map((dailyReport, index) => {
      return (
        <div key={index} className="waves-btn" style={[styles.row, index === dailyReports.length - 1 && styles.lastRow]}>
          <div style={styles.checkContainer}>
            {!dailyReport.approved ?
              <button type="button"
                title="Godkend dagrapport"
                className="btn btn-default"
                style={{ borderRadius: 0, padding: 7 }}
                onClick={() => toggleApproved(index, dailyReport.id, true)}>G</button>
              :
              <button type="button"
                title="Godkend dagrapport"
                className="btn btn-info"
                style={{ borderRadius: 0, padding: 7 }}
                onClick={() => toggleApproved(index, dailyReport.id, false)}>G</button>

            }
            {!dailyReport.invoiced ?
              <button type="button"
                title="Fakturer dagrapport"
                className="btn btn-default"
                style={{ borderRadius: 0, padding: 7 }}
                onClick={() => toggleInvoiced(index, dailyReport.id, true)}>F</button>
              :
              <button type="button"
                title="Fakturer dagrapport"
                className="btn btn-info"
                style={{ borderRadius: 0, padding: 7 }}
                onClick={() => toggleInvoiced(index, dailyReport.id, false)}>F</button>
            }
                        {!dailyReport.bog ?
              <button type="button"
                title="Bogfør dagrapport"
                className="btn btn-default"
                style={{ borderRadius: 0, padding: 7 }}
                onClick={() => toggleBog(index, dailyReport.id, true)}>B</button>
              :
              <button type="button"
                title="Bogfør dagrapport"
                className="btn btn-info"
                style={{ borderRadius: 0, padding: 7 }}
                onClick={() => toggleBog(index, dailyReport.id, false)}>B</button>
            }
          </div>
          <div style={[styles.dailyReportContainer]} onClick={() => goToDailyReport(dailyReport.date, dailyReport.id)}>
            <div className="pull-left">{getFullDateString(dailyReport.date, true)}</div>
            <div style={styles.time}>{dailyReport.creationTime}</div>

            <div style={styles.linkIcon}>#{dailyReport.version}</div>
          </div>
        </div>
      )
    })

    return (
      <div>
        <div style={styles.Heading}>
          <div style={styles.headingText}>Dagrapporter</div>
          <div className="waves-icon"
            style={styles.printAll}>
            <a href={_url} target="_blank" rel="noopener noreferrer">
              <i className="fa fa-print" aria-hidden="true" style={styles.printIcon}>
              </i>
            </a>
          </div>
        </div>
        <div style={styles.listsContainer}>
          {Items}
        </div>
      </div>

    );
  }
}


var styles = {
  listsContainer: {
    backgroundColor: '#fff',
    borderRadius: '2px'
  },
  row: {
    width: '96%',
    marginLeft: '1%',
    minHeight: '40px',
    textAlign: 'left',
    borderBottom: '1px solid',
    borderColor: semanticColors.mainBackground,
    fontSize: '12px',
    position: 'relative',
    padding: '0px',
    borderRadius: '0px'
  },
  dailyReportContainer: {
    paddingLeft: '85px',
    height: '38px',
    lineHeight: '38px',
    cursor: 'pointer'
  },
  linkIcon: {
    position: 'absolute',
    top: '0px',
    right: '65px',
    fontWeight: '600'
  },
  time: {
    float: 'right'
  },
  checkContainer: {
    position: 'absolute',
    left: '0px',
    fontSize: '20px',
    top: '2px'
  },
  isChecked: {
    color: semanticColors.text
  },
  lastRow: {
    borderBottom: 'none'
  },
  Heading: {
    paddingBottom: '10px',
    position: 'relative'
  },
  headingText: {
    display: 'inline-block'
  },
  headingCheckContainer: {
    position: 'absolute',
    left: '115px',
    top: '3px'
  },
  printAll: {
    position: 'absolute',
    left: '90%',
    top: '-4px',
    fontSize: '18px',
    height: '30px',
    width: '30px',
    lineHeight: '30px'
  },
  printIcon: {
    color: semanticColors.text
  },
  headingCheckContainerTwo: {
    left: '170px'
  },
  headingCheck: {
    fontSize: '18px',
    color: greyScaleColors.greyLight
  },
  headingCheckTwo: {
    color: greyScaleColors.greyLight
  },
  headingCheckText: {
    position: 'absolute',
    left: '17px',
    top: '-2px',
    width: '40px'
  }
}
DailyreportsList.propTypes = {
  dailyReports: PropTypes.arrayOf(PropTypes.shape({
    approved: PropTypes.bool.isRequired,
    invoiced: PropTypes.bool.isRequired,
    creationTime: PropTypes.string.isRequired,
    date: PropTypes.instanceOf(Date).isRequired,
    id: PropTypes.string.isRequired,
    version: PropTypes.number.isRequired
  })),
  toggleApproved: PropTypes.func.isRequired,
  toggleInvoiced: PropTypes.func.isRequired,
  toggleBog: PropTypes.func.isRequired,
  approvementCount: PropTypes.shape({
    approved: PropTypes.number.isRequired,
    notApproved: PropTypes.number.isRequired
  }).isRequired,
  goToDailyReport: PropTypes.func.isRequired,
  workplaceId: PropTypes.string.isRequired
};
export default Radium(DailyreportsList)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/dailyReportsList.jsx